import React from 'react';
import { Waves, BedDouble, Trees, Crown } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';

const icons = [Waves, BedDouble, Trees, Crown];

export const Highlights = () => {
  const { t } = useLanguage();
  const items = t('highlights.items');

  return (
    <section className="highlights-section">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="section-badge">{t('highlights.badge')}</div>
          <h2 className="section-title">{t('highlights.title')}</h2>
          <p className="section-description">{t('highlights.description')}</p>
        </div>

        <div className="highlights-grid">
          {Array.isArray(items) && items.map((item, index) => {
            const IconComponent = icons[index];
            return (
              <Card key={index} className="highlight-card">
                <CardContent className="highlight-card-content">
                  <div className="highlight-icon-wrapper">
                    <IconComponent className="highlight-icon" />
                  </div>
                  <h3 className="highlight-title">{item.title}</h3>
                  <p className="highlight-description">{item.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
